import playbackActions from "./playbackActions";
import {
  sendInitializePlaybackRequest,
  sendPlaybackCommandRequest,
} from "../../../api/votify.api";
import { playbackCommands } from "./playbackCommands";
import { sendGetTracksRequest } from "../../../api/spotify.api";

export const handleLoadPlayback = (playback) => {
  if (playback && playback.item) {
    const timeLeftMs = playback.item.duration_ms - playback.progress_ms;
    return {
      type: playbackActions.LOAD_PLAYBACK,
      payload: { playback, timeLeftMs },
    };
  } else {
    return { type: playbackActions.LOAD_EMPTY_PLAYBACK, payload: playback };
  }
};

export const handleNextTrack = ({ trackUri, timeLeftMs }) => {
  return async (dispatch) => {
    const trackOption = await sendGetTracksRequest([trackUri]);
    if (trackOption.ok) {
      console.log("nextTrackOption");
      console.log(trackOption);
      dispatch({
        type: playbackActions.LOAD_NEXT_TRACK,
        payload: { track: trackOption.data.tracks[0] },
      });
    } else {
      console.warn("Could not load next track details");
    }
    dispatch({
      type: playbackActions.HANDLE_NEXT_TRACK,
      payload: { trackUri, timeLeftMs },
    });
  };
};

export const sendPlaybackCommand = (command) => {
  return async (dispatch, getState) => {
    const { partyId } = getState().party;
    const { jwtToken } = getState().host;
    const responseOption = await sendPlaybackCommandRequest(
      command,
      partyId,
      jwtToken,
    );
    if (responseOption.ok) {
      switch (command) {
        case playbackCommands.PAUSE:
          dispatch({ type: playbackActions.PAUSE_PLAYBACK });
          break;
        case playbackCommands.STOP:
          dispatch({ type: playbackActions.STOP_PLAYBACK });
          break;
        case playbackCommands.SKIP:
          dispatch({ type: playbackActions.SKIP_PLAYBACK });
          break;
        case playbackCommands.PLAY:
          dispatch({ type: playbackActions.PLAY_PLAYBACK });
          break;
        case playbackCommands.START:
          dispatch({ type: playbackActions.START_PLAYBACK });
          break;
        default:
          console.warn(`Bad playback command: ${command}`);
          break;
      }
    } else {
      dispatch({
        type: playbackActions.FAIL_COMMAND,
        payload: responseOption.error,
      });
    }
  };
};

export const initializePlayback = () => {
  return async (dispatch, getState) => {
    dispatch({ type: playbackActions.START_INITIALIZE_PLAYBACK_REQUEST });
    const responseOption = await sendInitializePlaybackRequest(
      getState().party.partyId,
      getState().host.jwtToken,
    );
    console.log("initializePlayback");
    console.log("responseOption");
    console.log(responseOption);
    if (responseOption.ok) {
      dispatch({ type: playbackActions.SUCCESS_INITIALIZE_PLAYBACK });
    }
    dispatch({ type: playbackActions.END_INITIALIZE_PLAYBACK_REQUEST });
  };
};
